
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const steps = [
  {
    number: '01',
    title: 'Initial Consultation',
    description: 'Contact our team with your facility type, modality needs, and timeline. We assess your requirements within hours.',
    icon: 'ri-phone-line',
  },
  {
    number: '02',
    title: 'Site Assessment',
    description: 'Our logistics team evaluates your location for power, access, and connectivity requirements to ensure seamless setup.',
    icon: 'ri-survey-line',
  },
  {
    number: '03',
    title: 'Equipment Deployment',
    description: 'We transport, install, and configure your mobile imaging unit on-site — typically within 48 to 72 hours.',
    icon: 'ri-truck-line',
  },
  {
    number: '04',
    title: 'Operational Support',
    description: 'Ongoing maintenance, technical support, and optional staffing ensure uninterrupted imaging operations.',
    icon: 'ri-settings-3-line',
  },
];

export default function DeploymentProcess() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section ref={ref} className="py-16 sm:py-24 px-4 sm:px-6 bg-[#F7F9FB]">
      <div className="max-w-6xl mx-auto">
        <div
          className={`text-center mb-12 sm:mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <p className="text-slate-blue text-[13px] uppercase tracking-[2px] font-medium mb-3">
            HOW IT WORKS
          </p>
          <h2 className="text-navy text-[26px] sm:text-[36px] lg:text-[42px] font-semibold leading-tight mb-4">
            Rapid Deployment Process
          </h2>
          <p className="text-[#5A6C7D] text-base sm:text-lg max-w-2xl mx-auto">
            From first call to operational imaging — our streamlined process gets your facility up and running fast.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl p-6 sm:p-7 shadow-sm hover:shadow-lg transition-all duration-500 group ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 -right-4 w-8 h-[2px] bg-gray-200 z-10"></div>
              )}

              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-xl bg-navy/5 flex items-center justify-center group-hover:bg-navy group-hover:text-white transition-all duration-300">
                  <i className={`${step.icon} text-navy text-xl group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <span className="text-slate-blue/40 text-[28px] font-bold leading-none">{step.number}</span>
              </div>
              <h3 className="text-navy text-base sm:text-lg font-semibold mb-2">{step.title}</h3>
              <p className="text-[#5A6C7D] text-sm leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
